/**
 * Iter 31.237 — UTM capture hook.
 *
 * On mount, reads UTM params from window.location.search, fires one
 * anonymous POST to `/api/affiliates/utm-click`, and dedupes via
 * sessionStorage so reloads/back-button don't double-count.
 *
 * No PII. No cookies. No auth. Backend drops rows with no UTM params,
 * so calling this on every page load is safe (organic traffic is a no-op).
 */
import { useEffect } from "react";
import { api } from "@/lib/api";

export function useUtmCapture(landingPath = "") {
    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search);
            const utm = {
                utm_source: params.get("utm_source") || null,
                utm_medium: params.get("utm_medium") || null,
                utm_campaign: params.get("utm_campaign") || null,
                utm_content: params.get("utm_content") || null,
                utm_term: params.get("utm_term") || null,
            };
            // No utm params present? Don't bother the backend.
            if (!utm.utm_source && !utm.utm_campaign && !utm.utm_content) {
                return;
            }
            // Dedupe per session — same URL fired only once.
            const dedupeKey = `utm:${landingPath}:${window.location.search}`;
            if (sessionStorage.getItem(dedupeKey)) return;
            sessionStorage.setItem(dedupeKey, "1");
            api.post("/affiliates/utm-click", {
                ...utm,
                landing_path: landingPath || window.location.pathname,
                referrer: document.referrer || null,
            }).catch(() => {/* tracking is best-effort, never blocks UX */});
        } catch (_) {
            // Old browsers without URLSearchParams etc. — silently skip.
        }
    }, [landingPath]);
}
